import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ToolsService {
    constructor() {}

    removeFirst<T>(array: T[], toRemove: T): void {
        const index = array.indexOf(toRemove);
        if (index !== -1) {
            array.splice(index, 1);
        }
    }

    /**
     * Handle Http operation that failed.
     * Let the app continue.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            // TODO: send the error to remote logging infrastructure
            console.error(`${operation} failed: ${error.message}`, error); // log to console instead

            // TODO: better job of transforming error for user consumption
            // this.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }

    toISOLocal(date) {
        const z  = n =>  ('0' + n).slice(-2);
        const zz = n => ('00' + n).slice(-3);
        let off = date.getTimezoneOffset();
        let sign = off < 0? '+' : '-';
        off = Math.abs(off);
      
        return date.getFullYear() + '-'
               + z(date.getMonth()+1) + '-' +
               z(date.getDate()) + 'T' +
               z(date.getHours()) + ':'  + 
               z(date.getMinutes()) + ':' +
               z(date.getSeconds()) + '.' +
               zz(date.getMilliseconds()) +
               sign + z(off/60|0) + ':' + z(off%60); 
    }
      

    //#endregion
}
